export default "__VITE_ASSET__D7Dqpy0v__"